import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'

import api from '@/lib/api'
import { RemovaCharEspeciais } from '@/utils/format'

interface CreateParams {
  cnpj_data: any
  info_client: any
  info_contador: any
  Regime_produto: any
}

export function useCreateClientCPF() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ cnpj_data, info_client, info_contador, Regime_produto }: CreateParams) => {
      if (!user) throw new Error('Usuário não autenticado')
      const comissao = Number(Regime_produto.comissao)
      if (!Number.isFinite(comissao) || comissao < 20) {
        throw new Error('A comissão mínima para criar cliente é 20%.')
      }

      const atividadePrincipal = cnpj_data.atividade_principal?.[0]
      const document = String(cnpj_data.cnpj || cnpj_data.cpf || '').trim()
      const razaoSocial = cnpj_data.nome || cnpj_data.razao_social || info_client.cpf || ''
      const estado = cnpj_data.uf || cnpj_data.estado || ''
      const body = {
        cnpjcpf: document,
        cnae_principal: atividadePrincipal?.code || '',
        razao_social: razaoSocial,
        atividadePrincipal: atividadePrincipal?.text || '',
        isPF: Boolean(cnpj_data.isPF),
        cpfProprietario: info_client.cpf?.trim() || '',
        contatoProprietario: info_client.whatsapp.trim() || '',
        emailProprietario: info_client.email.trim() || '',
        nomeContador: info_contador.nome || '',
        contatoContador: info_contador.whatsapp.trim() || '',
        emailContador: info_contador.email.trim() || '',
        li_aceito_tenant: Regime_produto.concordo || false,
        status: 'PENDENTE',
        cep: RemovaCharEspeciais(cnpj_data.cep || ''),
        logradouro: cnpj_data.logradouro || '',
        bairro: cnpj_data.bairro || '',
        numero: cnpj_data.numero || '',
        municipio: cnpj_data.municipio || '',
        estado,
        complemento: cnpj_data.complemento || '',
        comissaoTenant: Number(Regime_produto.comissao) || 0,
        comissao_escrita: Regime_produto.comissaoEscrita || '',
        agencia: info_client.agencia,
        conta: info_client.conta,
        banco: info_client.banco
      }

      if (!body.cnpjcpf || !body.razao_social || !body.cpfProprietario) {
        throw new Error('Campos obrigatórios ausentes')
      }

      const response = await api.post(`/clients/cpf-Vinculo`, body, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) {
        return response.data
      } else {
        throw new Error('Erro ao criar cliente')
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] })
    }
  })
}
